<script setup lang="ts">
import { computed } from 'vue';

defineOptions({ inheritAttrs: false });

interface Props {
  name: string;
}

const props = defineProps<Props>();

const iconUrls = import.meta.glob('../../assets/icons/*.svg', { as: 'url', eager: true }) as Record<string, string>;

const imageSrc = computed(() => {
  const name = props.name?.trim();
  if (!name) return null;

  const path = `../../assets/icons/${name}.svg`;
  return iconUrls[path] || null;
});
</script>

<template>
  <img v-if="imageSrc" :src="imageSrc" :alt="props.name" v-bind="$attrs" />
</template>
